
const styles = {
    display: "flex",
    justifyContent: "end",
    flexDirection: "column",
    gap: "12px",
    backgroundColor: "transparent"
};
const inputStyles = {
    padding: "clamp(12px, 2vw, 16px)",
    paddingLeft: "clamp(14px, 2.5vw, 19px)",
    borderRadius: "5px",
    color: " #7f7f7f",
    fontFamily: "var(--font-paragraph)"
};
const radioStyles = {
    color: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "clamp(5px, 2vw, 15px)",
    fontFamily: "var(--font-paragraph)"
};
const optionStyles = {
    color: " #7f7f7f",
    fontWeight: "600"
}
const uploadBtnStyles = {
    backgroundColor: "transparent",
    fontFamily: "var(--font-paragraph)"
}
const labelStyles = {
    color: "black",
    fontWeight: "700",
    fontFamily: "var(--font-label",
    fontSize: "var(--font-label-size)"
};



export { styles, inputStyles, radioStyles, uploadBtnStyles, labelStyles, optionStyles, };